// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@adl/Overrides/Widgets/MyListsDetails/MyListsDetailsHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
        margin: -5px !important;
        align-items: center;

        & > * {
            padding: 5px;
            line-height: 1;

            &:before {
                content: "|";
                padding-right: 10px;
                color: ${getColor("common.ui2")};
            }
            &:first-child {
                &:before {
                    content: none;
                }
            }
        }
    `,
};

headerStyles.lastUpdateText = {
    size: 14,
    css: css`
        line-height: 18px;
    `,
};

headerStyles.sharingStatus = {
    statusText: {
        css: css`
            font-size: 14px;
            line-height: 18px;
        `,
    },
};

headerStyles.totalText = {
    size: 14,
    css: css`
        padding-left: 30px;
        line-height: 18px;
    `,
};

headerStyles.descriptionStyles = {
    heading: {
        css: css`
            display: none;
        `,
    },
    text: {
        size: 12,
        css: css`
            line-height: 18px;
        `,
    },
};

headerStyles.tagStyles = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
        `,
    },
    iconProps: {
        css: css`
            margin: 5px;
        `,
    },
    css: css`
        padding: 0 3px 0 10px;
        min-height: 0;
        &&&& {
            max-width: 100%;
        }
    `,
};
